const API_URL_KEY = 'eliquidesud_api_url';

// ── Switcher DEV / PROD ──────────────────────────────────────────────────────
//export const DEFAULT_API_URL = "http://localhost:5117/api"; // DEV LOCAL                         // DEV (local)
export const DEFAULT_API_URL = 'https://api.eliquidesud.com/api/'; // PRODUCTION
// ────────────────────────────────────────────────────────────────────────────

export function getApiBaseUrl(): string {
  return localStorage.getItem(API_URL_KEY) || DEFAULT_API_URL;
}

export function setApiBaseUrl(url: string): void {
  // S'assurer que l'URL finit par /
  const normalized = url.endsWith('/') ? url : url + '/';
  localStorage.setItem(API_URL_KEY, normalized);
}

export function resetApiBaseUrl(): void {
  localStorage.removeItem(API_URL_KEY);
}
